var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comments"},[_c('img',{attrs:{"src":_vm.user.thumbnail,"alt":""}}),_c('input',{attrs:{"type":"text","placeholder":"Say something about it..."}}),_c('button',{on:{"click":_vm.commentCreate}},[_vm._v("Add comment")])])}
var staticRenderFns = []

export { render, staticRenderFns }